export default function FeatureCards() {
  const features = [
    {
      title: 'Automated Tracking',
      subtitle: 'Replace manual logs with smart order tracking',
      bgUrl: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20clean%20white%20desk%20displaying%20colorful%20order%20tracking%20dashboard%2C%20small%20potted%20succulent%20beside%20it%2C%20soft%20natural%20daylight%20from%20window%2C%20productive%20workspace%20photography%2C%20clean%20organized%20aesthetic%2C%20warm%20minimal%20atmosphere&width=600&height=600&seq=feat-tracking-v2&orientation=squarish',
    },
    {
      title: 'Profit Calculator',
      subtitle: 'Built-in formulas for instant margin analysis',
      bgUrl: 'https://readdy.ai/api/search-image?query=Multiple%20neatly%20stacked%20clothing%20piles%20in%20earth%20tones%20on%20light%20bamboo%20surface%20with%20calculator%20and%20notebook%20nearby%2C%20soft%20overhead%20studio%20lighting%2C%20business%20organization%20photography%2C%20warm%20neutral%20palette%2C%20systematic%20arrangement&width=600&height=600&seq=feat-profit-v2&orientation=squarish',
    },
    {
      title: 'Workflow Sync',
      subtitle: 'Seamless integration with Sheets and Excel',
      bgUrl: 'https://readdy.ai/api/search-image?query=Tablet%20and%20smartphone%20side%20by%20side%20on%20light%20grey%20desk%20showing%20synced%20spreadsheet%20interface%2C%20fashion%20accessory%20samples%20scattered%20around%2C%20cool%20diffused%20morning%20light%2C%20tech%20productivity%20photography%2C%20clean%20modern%20aesthetic%2C%20connected%20workflow%20concept&width=600&height=600&seq=feat-sync-v2&orientation=squarish',
    },
  ];

  return (
    <section className="w-full bg-background-100 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 text-center">
          Why Choose ACBuySpreadsheet?
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat, idx) => (
            <div key={idx} className="relative group rounded-lg overflow-hidden aspect-[4/3] cursor-pointer">
              <img
                src={feat.bgUrl}
                alt={`${feat.title} - ACBuySpreadsheet feature`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-black/20"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                <h3 className="text-lg md:text-xl font-heading font-bold text-white">
                  {feat.title}
                </h3>
                <p className="mt-2 text-sm text-white/80">
                  {feat.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}